export const GUIDE_ID = '7953' // ID for the /guide page
export const CATEGORIES_ID = {
    "actualites": "43",
    "a-propos": "499",
    "etudes": "496",
} // list WP category's IDs
export const REDACTION_PAGE_ID = 205367 // ID for /guide/a-propos/redaction page
export const REDACTION_USER_ID = 76 // ID for redaction user
export const LOAN_RATE_BANK_PAGE_ID = '290' // ID for/guide/pret-immobilier/banques
export const INSURANCES_PAGE_ID = '219993' // ID for /nos-assurances page
